import { Card } from "@/components/ui/card";

export default function Terms() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-6">
      <Card className="max-w-2xl w-full p-8 shadow-lg border border-border bg-card">
        <h1 className="text-3xl font-bold mb-4 text-foreground">
          Terms & Conditions
        </h1>
        <p className="mb-4 text-foreground">
          Welcome. By using our application, you agree to the following terms
          and conditions. Please read them carefully.
        </p>
        <ul className="list-disc pl-6 space-y-2 text-foreground">
          <li>
            You must provide accurate information when creating an account.
          </li>
          <li>
            You are responsible for maintaining the confidentiality of your
            account credentials.
          </li>
          <li>
            Use of this application for unlawful purposes is strictly
            prohibited.
          </li>
          <li>
            We reserve the right to update these terms at any time. Continued
            use of the application constitutes acceptance of any changes.
          </li>
          <li>
            All content and intellectual property within the application is
            owned by Party Schedule Pal and may not be reproduced without
            permission.
          </li>
        </ul>
        <p className="mt-6 text-foreground">
          If you have any questions about these terms, please contact support.
        </p>
      </Card>
    </div>
  );
}
